import React from 'react';
import { useNavigate } from 'react-router-dom';
import ResponsiveTable from './ResponsiveTable';

function AlbumsTable({ data, totalCount, currentPage, pageSize, searchKeyword }) {
  const navigate = useNavigate();

  const columns = React.useMemo(
    () => [
      {
        Header: '순번',
        id: 'row',
        Cell: ({ row }) =>
          totalCount - ((currentPage - 1) * pageSize + row.index),
      },
      {
        Header: '커버',
        accessor: 'image',
        Cell: ({ row }) => (
          <img
            src={
              row.original.image ||
              'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg'
            }
            alt={row.original.nameKr}
            className="w-12 h-12 rounded-full object-cover mx-auto shadow border border-white/[0.08]"
          />
        ),
      },
      {
        Header: '앨범명',
        accessor: 'nameKr',
        Cell: ({ row }) => (
          <span
            className="font-bold text-sky-400 cursor-pointer hover:underline"
            onClick={() => {
              const searchParam = searchKeyword ? `&search=${encodeURIComponent(searchKeyword)}` : '';
              navigate(`/Albums/${row.original.id}?page=${currentPage}${searchParam}`);
            }}>
            {row.original.nameKr}
          </span>
        ),
      },
      {
        Header: '아티스트',
        accessor: 'artist.nameKr',
        Cell: ({ row }) => row.original.artist?.nameKr || '',
      },
      {
        Header: '권리사',
        accessor: 'clientDisplay',
      },
      {
        Header: '발매일',
        accessor: 'releaseDateTime',
      },
    ],
    [navigate, totalCount, currentPage, pageSize, searchKeyword]
  );

  return (
    <ResponsiveTable
      columns={columns}
      data={data}
      visibleOnMobile={['row', 'image', 'nameKr', 'artist.nameKr']}
    />
  );
}

export default AlbumsTable;
